import React from 'react';
import Text from 'fe-design-base/atoms/Text';
import Alert from 'fe-design-base/molecules/Alert';
import Link from 'fe-design-base/molecules/Link';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

import Section from '../../Section';

const { cx } = cxHelpers('MissingMandatedBreaks');

const MissingMandatedBreaks = () => (
  <Section
    className={cx()}
    iconName="Break"
    collapsedContent={
      <Alert
        variant="info"
        forceStacked
        action={
          <Link href="/settings/time_tracking/breaks" size="small">
            {toI18n('timecard_modal_v3.timebreaks_section.go_to_settings')}
          </Link>
        }
      >
        <Text
          variant="body"
          i18n="timecard_modal_v3.timebreaks_section.missing_mandated_breaks"
        />
      </Alert>
    }
  />
);

export default MissingMandatedBreaks;
